import React from "react";
export function Story() {
  return <section id="historia" className="mx-auto max-w-5xl px-6 py-16 sm:py-24" data-id="element-111" data-mp="2smy76c0i9l59">
      <p className="mb-3 font-semibold text-accent" data-id="element-112" data-mp="1ibdmzvaobg6w">Marcos Rosell</p>
      <h2 className="mb-6 font-serif text-[30px] font-bold leading-tight sm:text-5xl" data-id="element-113" data-mp="1n3dnbounob40">
        Aprender, implementar y seguir avanzando
      </h2>
      <div className="max-w-3xl space-y-5 text-lg leading-relaxed text-soft" data-id="element-114" data-mp="1s1p2mf3pzdtm">
        <p data-id="element-115" data-mp="ufhwh0rrpdf5">
          Soy papá de dos nenas y me apasionan las motos. Poder compartir tiempo con mi familia es una parte importante
          de por qué elegí emprender por internet.
        </p>
        <p data-id="element-116" data-mp="14bkx226z13zz">
          Cuando empecé en el marketing digital, también tuve que aprender desde cero. Hoy comparto lo que aprendí para
          ayudarte a crear tu producto, preparar tu oferta y dar tus primeros pasos en la venta online.
        </p>
        <p data-id="element-117" data-mp="2fu5icizzitpr">
          Eso es Radar Digital: formación y acompañamiento para pasar de mirar contenido a trabajar sobre tu propio
          proyecto.
        </p>
      </div>
    </section>;
}